import { useQuery } from '@tanstack/react-query';

import { fetchFollowingRelationship } from './api';

import { RQ_FOLLOWING_RELATIONSHIP } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type UseFollowingRelationshipParams = {
  sellerId: number;
  username: string;
};

export function useFollowingRelationship({
  sellerId,
  username,
}: UseFollowingRelationshipParams) {
  const [isAuthenticated] = useCurrentUser();

  return useQuery({
    queryKey: [RQ_FOLLOWING_RELATIONSHIP, username],
    queryFn: () => fetchFollowingRelationship(sellerId),
    enabled: isAuthenticated,
  });
}
